import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      let errorMessage = "Ndodhi një gabim i papritur.";
      
      try {
        // Kontrollo nëse gabimi është një FirestoreErrorInfo i serializuar
        const parsedError = JSON.parse(this.state.error?.message || "");
        if (parsedError.error && parsedError.operationType) {
          errorMessage = `Gabim në bazën e të dhënave: ${parsedError.error} (Gjatë ${parsedError.operationType})`;
        }
      } catch (e) {
        // Nuk është JSON, përdor mesazhin origjinal nëse është i përshtatshëm
        if (this.state.error?.message && !this.state.error.message.includes('{')) {
          errorMessage = this.state.error.message;
        }
      }

      return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-indigo-950 text-white">
          <div className="max-w-md w-full glass-card p-8 rounded-3xl border border-white/20 text-center">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <span className="text-3xl">⚠️</span>
            </div>
            <h1 className="text-2xl font-bold mb-4">Ups! Diçka shkoi keq</h1>
            <p className="text-indigo-200 mb-8">{errorMessage}</p>
            <button
              onClick={() => window.location.reload()}
              className="w-full py-4 bg-indigo-500 hover:bg-indigo-400 rounded-2xl font-bold transition-all shadow-lg shadow-indigo-500/20"
            >
              Rifillo Aplikacionin
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
